export const HIGHLIGHT_LINE_REQ = 'HIGHLIGHT_LINE_REQ';
export const HIGHLIGHT_LINE_OK = 'HIGHLIGHT_LINE_OK';

export const UNHIGHLIGHT_LINE_REQ = 'UNHIGHLIGHT_LINE_REQ';

export const UPDATE_SCRIPT_TEXT_IN_EDITOR = 'UPDATE_SCRIPT_TEXT_IN_EDITOR';

export const OPEN_ERRORS_IN_ERROR_PANEL_REQ = 'OPEN_ERRORS_IN_ERROR_PANEL_REQ';

export const CHANGE_EDITOR_FONT_SIZE_REQ = 'CHANGE_EDITOR_FONT_SIZE_REQ';
export const CHANGE_EDITOR_FONT_SIZE_OK = 'CHANGE_EDITOR_FONT_SIZE_OK';

export const CHANGE_EDITOR_THEME_REQ = 'CHANGE_EDITOR_THEME_REQ';
export const CHANGE_EDITOR_THEME_OK = 'CHANGE_EDITOR_THEME_OK';

export const SCRIPT_SEARCH_SHOW_REQ = 'SCRIPT_SEARCH_SHOW_REQ';
export const SCRIPT_SEARCH_SHOW_OK = 'SCRIPT_SEARCH_SHOW_OK';

export const SCRIPT_SEARCH_UPDATE_REQ = 'SCRIPT_SEARCH_UPDATE_REQ';
export const SCRIPT_SEARCH_UPDATE_OK = 'SCRIPT_SEARCH_UPDATE_OK';

export const SCRIPT_SEARCH_SEARCH_TERM_REQ = 'SCRIPT_SEARCH_SEARCH_TERM_REQ';
export const SCRIPT_SEARCH_SEARCH_TERM_OK = 'SCRIPT_SEARCH_SEARCH_TERM_OK';

export const SCRIPT_SEARCH_REPLACE_TERM_REQ = 'SCRIPT_SEARCH_REPLACE_TERM_REQ';
export const SCRIPT_SEARCH_REPLACE_TERM_OK = 'SCRIPT_SEARCH_REPLACE_TERM_OK';

export const SCRIPT_SEARCH_SET_META_REQ = 'SCRIPT_SEARCH_SET_META_REQ';
export const SCRIPT_SEARCH_SET_META_OK = 'SCRIPT_SEARCH_SET_META_OK';

export const SCRIPT_SEARCH_RESET_REQ = 'SCRIPT_SEARCH_RESET_REQ';
export const SCRIPT_SEARCH_RESET_OK = 'SCRIPT_SEARCH_RESET_OK';
